export const languages = [
    { label: "Afrikaans", code: "af-ZA" },
    { label: "Arabic, Gulf", code: "ar-AE" },
    { label: "Arabic, Modern Standard", code: "ar-SA" },
    { label: "Basque", code: "eu-ES" },
    { label: "Catalan", code: "ca-ES" },
    { label: "Chinese (Cantonese), Hong-Kong", code: "zh-HK" },
    { label: "Chinese, Simplified", code: "zh-CN" },
    { label: "Chinese, Traditional", code: "zh-TW" },
    { label: "Croatian", code: "hr-HR" },
    { label: "Czech", code: "cs-CZ" },
    { label: "Danish", code: "da-DK" },
    { label: "Dutch", code: "nl-NL" },
    { label: "English, Australian", code: "en-AU" },
    { label: "English, British", code: "en-GB" },
    { label: "English, Indian", code: "en-IN" },
    { label: "English, Irish", code: "en-IE" },
    { label: "English, New Zealand", code: "en-NZ" },
    { label: "English, Scottish", code: "en-AB" },
    { label: "English, South African", code: "en-ZA" },
    { label: "English, US", code: "en-US" },
    { label: "English, Welsh", code: "en-WL" },
    { label: "Farsi", code: "fa-IR" },
    { label: "Finnish", code: "fi-FI" },
    { label: "French", code: "fr-FR" },
    { label: "French, Canadian", code: "fr-CA" },
    { label: "Galician", code: "gl-ES" },
    { label: "German", code: "de-DE" },
    { label: "German, Swiss", code: "de-CH" },
    { label: "Greek", code: "el-GR" },
    { label: "Hebrew", code: "he-IL" },
    { label: "Hindi", code: "hi-IN" },
    { label: "Indonesian", code: "id-ID" },
    { label: "Italian", code: "it-IT" },
    { label: "Japanese", code: "ja-JP" },
    { label: "Korean", code: "ko-KR" },
    { label: "Latvian", code: "lv-LV" },
    { label: "Malay", code: "ms-MY" },
    { label: "Norwegian Bokmål", code: "no-NO" },
    { label: "Polish", code: "pl-PL" },
    { label: "Portuguese", code: "pt-PT" },
    { label: "Portuguese, Brazilian", code: "pt-BR" },
    { label: "Romanian", code: "ro-RO" },
    { label: "Russian", code: "ru-RU" },
    { label: "Serbian", code: "sr-RS" },
    { label: "Slovak", code: "sk-SK" },
    { label: "Somali", code: "so-SO" },
    { label: "Spanish", code: "es-ES" },
    { label: "Spanish, US", code: "es-US" },
    { label: "Swedish", code: "sv-SE" },
    { label: "Tagalog/Filipino", code: "tl-PH" },
    { label: "Thai", code: "th-TH" },
    { label: "Ukrainian", code: "uk-UA" },
    { label: "Vietnamese", code: "vi-VN" },
    { label: "Zulu", code: "zu-ZA" }
  ];
  